import { render, staticRenderFns } from "./pgame.vue?vue&type=template&id=97d67bde&scoped=true&"
import script from "./pgame.vue?vue&type=script&lang=js&"
export * from "./pgame.vue?vue&type=script&lang=js&"
import style0 from "./pgame.vue?vue&type=style&index=0&id=97d67bde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97d67bde",
  null
  
)

export default component.exports